import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const renderSpecValue = (val) => {
  if (val === null || val === undefined) return 'N/A';
  if (typeof val === 'boolean') return val ? 'Yes' : 'No';
  if (typeof val === 'object') {
    if (Array.isArray(val)) {
      if (val.length === 0) return 'None';
      if (val.every(item => typeof item !== 'object')) {
        return val.join(', ');
      }
      return (
        <div className="space-y-1.5 pl-2 border-l border-indigo-500/20">
          {val.map((item, idx) => (
            <div key={idx} className="text-xs bg-slate-900/40 p-1.5 rounded">
              {renderSpecValue(item)}
            </div>
          ))}
        </div>
      );
    }
    return (
      <div className="grid grid-cols-2 gap-1.5 text-xs text-slate-300">
        {Object.entries(val).map(([k, v]) => (
          <div key={k}>
            <span className="text-[10px] text-muted-foreground uppercase block font-semibold">{k.replace(/_/g, ' ')}</span>
            <span>{renderSpecValue(v)}</span>
          </div>
        ))}
      </div>
    );
  }
  return String(val);
};

const MobileSpecsDrawer = ({ isOpen, onClose, model, onAddParentToCart }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed top-[104px] bottom-0 left-0 right-0 z-[1001] flex flex-col bg-background overflow-hidden animate-in slide-in-from-bottom duration-300">
      <div className="flex items-center justify-between p-4 border-b border-border shrink-0">
        <h3 className="font-bold text-lg">Model Specs</h3>
        <Button variant="ghost" size="sm" onClick={onClose} className="shrink-0">
          <Icon name="X" size={24} />
        </Button>
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-6">
        <div>
          <h4 className="text-sm font-bold text-foreground mb-2 flex items-center justify-between">
            Description
            {model?.isCertified && (
              <img 
                src="/assets/images/3dFactoryApprovedGearsWhite100x100.png" 
                alt="Factory Certified" 
                className="h-8 w-8 object-contain drop-shadow-sm"
              />
            )}
          </h4>
          <p className="text-sm text-muted-foreground leading-relaxed whitespace-pre-wrap">
            {model?.description || 'No description available.'}
          </p>
        </div>
        
        <div className="space-y-4">
        {(() => {
          const parsedSpecs = typeof model?.specs === 'string' ? (() => {
            try { return JSON.parse(model.specs); } catch { return {}; }
          })() : (model?.specs || {});
          
          const hasSpecs = Object.keys(parsedSpecs).length > 0;
          if (!hasSpecs) {
            return (
              <div className="space-y-3">
                 <div className="grid grid-cols-2 gap-4">
                   <div className="bg-muted/30 p-3 rounded-lg">
                     <p className="text-xs text-muted-foreground mb-1">File Size</p>
                     <p className="text-sm font-medium text-foreground">{model?.fileSize || model?.file_size || 'N/A'}</p>
                   </div>
                   <div className="bg-muted/30 p-3 rounded-lg">
                     <p className="text-xs text-muted-foreground mb-1">Polygons</p>
                     <p className="text-sm font-medium text-foreground">{model?.polygons || 'N/A'}</p>
                   </div>
                 </div>
                 <div className="bg-muted/30 p-3 rounded-lg">
                   <p className="text-xs text-muted-foreground mb-1">Dimensions</p>
                   <p className="text-sm font-medium text-foreground">{model?.dimensions || 'N/A'}</p>
                 </div>
              </div>
            );
          }
          return (
            <div className="space-y-4">
               {Object.entries(parsedSpecs).map(([key, value]) => {
                 if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                   return (
                     <div key={key} className="pt-2 pb-2 border-b border-border/40 last:border-b-0 text-left">
                        <p className="text-sm font-bold text-foreground uppercase tracking-wider mb-2 border-b border-border pb-1">{key.replace(/_/g, ' ')}</p>
                        <div className="mt-1">
                          {renderSpecValue(value)}
                        </div>
                     </div>
                   );
                 }
                 return (
                   <div key={key} className="flex justify-between items-center py-2 px-3 bg-muted/30 rounded-lg text-left">
                      <p className="text-xs text-muted-foreground capitalize font-bold">{key.replace(/_/g, ' ')}</p>
                      <p className="text-xs font-medium text-foreground text-right">{renderSpecValue(value)}</p>
                   </div>
                 );
               })}
            </div>
          );
        })()}
      </div>

        <div className="bg-muted/30 p-3 rounded-lg">
          <p className="text-xs text-muted-foreground mb-1">Dimensions</p>
          <p className="text-sm font-medium text-foreground">{model?.dimensions || 'N/A'}</p>
        </div>
      </div>

      {(model?.sellProductOnly || model?.sell_product_only) && (
        <div className="p-4 border-t border-border bg-background shrink-0">
          <Button
            type="button"
            variant="default"
            size="lg"
            className="w-full text-xs font-black uppercase tracking-widest shadow-xl border-b-4 border-primary/50"
            iconName="ShoppingCart"
            onClick={() => {
              if (onAddParentToCart) {
                onAddParentToCart();
                onClose();
              }
            }}
          >
            Add to Cart
          </Button>
        </div>
      )}
    </div>
  );
};

export default MobileSpecsDrawer;
